import * as Sentry from "@sentry/react";

export const trackButtonClick = (buttonName: string) => {
  try {
    Sentry.metrics.count("button_click", 1, {
      attributes: { button: buttonName },
    });
  } catch {
    // Silently fail - tracking should never break the app
  }
};
